import requests from "./httpService";

const SallerServices = {

    getAllSellers: async () => {
        return requests.get(`/seller`);
    },
    getAllSellersBankList: async () => {
        return requests.get(`/seller/bank-list`);
    },

    getTodayUser: async () => {
        return requests.get(`/admin/today-customer`);
    },
    getSellerBankList: async () => {
        return requests.get(`/seller/bank-list`);
    },
    getActiveSeller: async () => {
        return requests.get(`/seller/active`);
    },
    getState: async () => {
        return requests.get(`/newlocation/states`);
    },
    getCities: async (id) => {
        return requests.get(`/newlocation/cities/${id}`);
    },
    getSubcriptionUsers: async () => {
        return requests.get(`/userSubscription/active`);
    },

    getSubcriptionAllUsers: async () => {
        return requests.get(`/userSubscription`);
    },

    expireSubcriptionAllUsers: async () => {
        return requests.get(`/userSubscription/expire`);
    },
    pandingSubcriptionAllUsers: async () => {
        return requests.get(`/userSubscription/pending`);
    },
    getINActiveSeller: async () => {
        return requests.get(`/seller/inactive`);
    },

    getBlockSeller: async () => {
        return requests.get(`/seller/block`);
    },


    getAllVendor: async () => {
        return requests.get(`/user/vendor`);
    },

    getregisterVendor: async () => {
        return requests.get(`/user/vendor/register`);
    },

 
    getAllBlockVendor: async () => {
        return requests.get(`/user/vendor/block`);
    },


    updateSellerStatus: async (id, body) => {
        return requests.patch(`/seller/updateStatus/${id}`, body);
    },

    updateSellerblockStatus: async (id, body) => {
        return requests.patch(`/seller/updateBlockStatus/${id}`, body);
    },

    updateSeller: async (id, body) => {

        return requests.patch(`/seller/${id}`, body);
    },

    updateVendorStatus: async (id, body) => {

        return requests.patch(`/user/vendor/updateStatus/${id}`, body);
    },


    getAllVehicle: async () => {
        return requests.get(`/vehical`);
    },

    getContactDetail: async () => {
        return requests.get(`/contact`);
    },

    updateContactDetail: async (id, body) => {
        return requests.patch(`/contact/${id}`, body);
    },


  createSeller: async (body) => {

        return requests.post(`/seller`, body);
    },
    getHolidayDetail: async () => {
        return requests.get(`/holiday-app/holidays-admin`);
    },


    updateHolidayDetail: async (id, body) => {
        return requests.patch(`/holiday-app/holidays/${id}`, body);
    },

    deleteSeller: async (id) => {
        return requests.delete(`/seller/${id}`);
    },


    allordersOfVender: async (id) => {
        return requests.post(`booking/all-orders-Of-Vender/${id}`);
    },
    deleteVendor: async (id) => {

        return requests.delete(`/user/vendor/${id}`);
    },

    assignVerificationToDoctor: async (verificationId, doctorId) => {
        return requests.post('/verification/assign', { verificationId, doctorId });
    },

    getAllVendorAttendance: async (id) => {
        return requests.get(`/user/vendor/attendance/${id}`);
    },

    getUserActivity: async (payload) => {
        return requests.post("/user/userActivity", payload);
    }


}

export default SallerServices;